/// <reference path="../../../typings/browser.d.ts" />

namespace Application.Controllers {
    'use strict';

    export interface IProbeModalScope extends ng.IScope {
        title: string;
        probe: Models.IProbe;
        networks: Models.Network[];
        selectedNetwork: Models.INetwork;
        modalClose: () => void;
        modalSave: () => void;
    }

    /**
     * ProbeModalController class
     */
    export class ProbeModalController {
        public static templateURL: string = "decorators/modals/probe-modal.html";
        public static ID: string = "#id-probe-modal";
        public static $name: string = "probeModalController";
        public static $inject: string[] = ['$scope', 'close', '$timeout', 'title', 'probe', 'networks'];

        private $scope: IProbeModalScope;
        private close: (parameters: ngModal.ICloseParameters) => void;

        /**
         * Constructor
         */
        constructor($scope: IProbeModalScope,
                    close: (parameters: ngModal.ICloseParameters) => void,
                    $timeout: ng.ITimeoutService,
                    title: string,
                    probe: Models.IProbe,
                    networks: Models.Network[]) {
            $timeout(() => {
                window.altair_admin_common_init();
                window.altair_forms_validation();
            }, 500);

            this.$scope = $scope;
            this.$scope.title = title;
            this.$scope.probe = probe;
            this.$scope.networks = networks;
            this.close = close;

            // probes only have one network interface
            // creates it if not present (new probe)
            if (probe.networkInterfaces[0])
                this.$scope.selectedNetwork = probe.networkInterfaces[0].networkConnectedTo;
            else
                probe.networkInterfaces[0] = Application.Models.NetworkInterface.Empty();

            this.$scope.modalClose = (): void => {
                this.close(undefined);
            };

            this.$scope.modalSave = (): void => {
                if (probe.name !== undefined && probe.name !== "") {
                    if (probe.networkInterfaces[0])
                        probe.networkInterfaces[0].networkConnectedTo = this.$scope.selectedNetwork;
                    this.close(probe);
                }
            };
        }
    }
}
